import * as React from 'react'
import colors from 'theme/colors'

const SvgComponent = ({
  color = colors.white,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 17
  const h = 17
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.31991 9.17034C7.87391 9.17034 7.42924 9.02301 7.05724 8.72834L4.06724 6.31768C3.85191 6.14434 3.81857 5.82901 3.99124 5.61434C4.16524 5.40034 4.47991 5.36634 4.69457 5.53901L7.68191 7.94701C8.05724 8.24434 8.58591 8.24434 8.96391 7.94434L11.9212 5.54034C12.1359 5.36501 12.4506 5.39834 12.6252 5.61301C12.7992 5.82701 12.7666 6.14168 12.5526 6.31634L9.58991 8.72434C9.21524 9.02168 8.76724 9.17034 8.31991 9.17034Z"
        fill={color}
      />
      <mask
        id="mask0_1270_33639"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="15"
        height="14"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.13477 1.52734H15.468V14.5273H1.13477V1.52734Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask0_1270_33639)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.02741 13.5273H11.5741C11.5754 13.526 11.5807 13.5273 11.5847 13.5273C12.3454 13.5273 13.0201 13.2553 13.5374 12.7387C14.1381 12.1407 14.4681 11.2813 14.4681 10.3193V5.74065C14.4681 3.87865 13.2507 2.52732 11.5741 2.52732H5.02875C3.35208 2.52732 2.13475 3.87865 2.13475 5.74065V10.3193C2.13475 11.2813 2.46541 12.1407 3.06541 12.7387C3.58275 13.2553 4.25808 13.5273 5.01808 13.5273H5.02741ZM5.0161 14.5273C3.98743 14.5273 3.06877 14.154 2.35943 13.4473C1.56943 12.6593 1.13477 11.5487 1.13477 10.3193V5.74068C1.13477 3.33868 2.80877 1.52734 5.02877 1.52734H11.5741C13.7941 1.52734 15.4681 3.33868 15.4681 5.74068V10.3193C15.4681 11.5487 15.0334 12.6593 14.2434 13.4473C13.5348 14.1533 12.6154 14.5273 11.5848 14.5273H11.5741H5.02877H5.0161Z"
          fill={color}
        />
      </g>
    </svg>
  )
}

export default SvgComponent
